export default __webpack_public_path__ + "static/media/Feedback-5.3942eb3a.svg";